module.exports = __webpack_public_path__ + "img/Mail.b10b9f1e.svg";